export default {
  namespaced: true,

  state: {
    pagination: {
      page: null,
      itemsLength: null,
      pageCount: null,
    },
    itemsPerPage: 12,
  },

  mutations: {
    SET_PAGINATION(state, pagination) {
      state.pagination = pagination;
    },

    SET_PAGE(state, page) {
      state.pagination.page = page;
    },

    SET_ITEMS_PER_PAGE(state, items) {
      state.itemsPerPage = items;
      state.pagination.page = 1;
    },

    CLEAR_PAGINATION(state) {
      state.pagination = {
        page: null,
        itemsLength: null,
        pageCount: null,
      };
      state.itemsPerPage = 12;
    },
  },

  actions: {
    setPagination({ commit }, pagination) {
      return new Promise((resolve) => {
        commit('SET_PAGINATION', pagination);
        resolve();
      });
    },

    setPage({ commit }, page) {
      return new Promise((resolve) => {
        commit('SET_PAGE', page);
        resolve();
      });
    },

    setItemsPerPage({ commit }, items) {
      return new Promise((resolve) => {
        commit('SET_ITEMS_PER_PAGE', items);
        resolve();
      });
    },

    resetPagination({ commit }) {
      return new Promise((resolve) => {
        commit('CLEAR_PAGINATION');
      });
    },
  },
};
